import { render, staticRenderFns } from "./AccountSubheader.vue?vue&type=template&id=8645a03e&scoped=true&lang=html&"
import script from "./AccountSubheader.vue?vue&type=script&lang=js&"
export * from "./AccountSubheader.vue?vue&type=script&lang=js&"
import style0 from "./AccountSubheader.vue?vue&type=style&index=0&id=8645a03e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8645a03e",
  null
  
)

export default component.exports